import $ from 'jquery'

/**
 * Handle toggle off canvas events.
 */
function onToggleOffCanvas() {
  $('.sidebar-offcanvas').toggleClass('active')
}

/**
 * Add an event listener for toggling off canvas events.
 */
function listenToToggleOffCanvas() {
  $('[data-toggle="offcanvas"]').on('click', onToggleOffCanvas)
}

export { listenToToggleOffCanvas }
